import React from 'react';
import styled from 'styled-components';

const Footer = () => {
  
  return (
    <FooterContainer>
        <img src="images/logo/cs-logo.png" /><br />
        <span>&copy;ColumbiaSoft Corporation</span>
        <a href="http://www.documentlocator.com" target="_blank">www.DocumentLocator.com</a>
    </FooterContainer>
  )
}

const FooterContainer = styled.div`
	margin-top: 20px;
	text-align: center;
	a:hover {
		color: #fff;
		text-decoration: underline;
	}
	span, a {
		width: 160px;
		margin: auto;
		display: block;
		color: #bfc4c8;
		font-size: 10px;
		text-decoration: none;
	}
	span {
		margin-top: 5px;
		cursor: default;
	}
`
export default Footer;